/**
 * 主题切换按钮（T05 / 架构 §1.1）
 *  - 点击 useThemeMode().toggle() 切换 light/dark；
 *  - 图标随当前模式变化（浅色显示月亮☾，深色显示太阳☀），点击即去对侧模式。
 */
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Brightness4Icon from '@mui/icons-material/Brightness4'; // 月亮（当前为浅色时显示，点去深色）
import Brightness7Icon from '@mui/icons-material/Brightness7'; // 太阳（当前为深色时显示，点去浅色）
import { useThemeMode } from '../../theme/ThemeModeProvider';

export default function ThemeToggleButton() {
  const { mode, toggle } = useThemeMode();
  const isLight = mode === 'light';
  return (
    <Tooltip title={isLight ? '切换到深色' : '切换到浅色'}>
      <IconButton onClick={toggle} color="inherit" aria-label="切换主题">
        {isLight ? <Brightness4Icon /> : <Brightness7Icon />}
      </IconButton>
    </Tooltip>
  );
}
